<template>
  <v-card flat>
    <v-card-text>
      <v-tabs v-model="tab" :height="60" show-arrows center-active>
        <v-tab v-for="category in categories" :key="category.value" :ripple="false">
          {{ category.text }} ({{ getDocumentCount(category.value) }})
        </v-tab>
        <v-tab :ripple="false">
          {{ $t('companiesDetails.archive') }} ({{ archivedCount }})
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="category in categories" :key="category.value">
          <TSLDocumentsList
            v-if="tab === categories.findIndex(c => c.value === category.value)"
            :document-type="category.value"
            :contractor-id="contractorId"
            @update="getDocumentsCount"
          />
        </v-tab-item>
        <v-tab-item>
          <TSLArchive
            v-if="tab === categories.length"
            :contractor-id="contractorId"
            :contractor-type="contractorType"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import Service from '@/services'
import TSLDocumentsList from './components/TSLDocumentsList.vue'
import TSLArchive from './components/TSLArchive.vue'

export default {
  name: 'Documents',
  components: {
    TSLDocumentsList,
    TSLArchive
  },
  props: {
    contractorId: {
      type: String,
      required: true
    },
    contractorType: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      tab: 0,
      loading: false,
      documentsCount: {},
      archivedCount: 0
    }
  },
  computed: {
    categories () {
      if (this.contractorType === 1) { // Client
        return [
          { text: this.$t('tslContractors.documentCategories.vat'), value: 5 },
          { text: this.$t('tslContractors.documentCategories.certificates'), value: 6 },
          { text: this.$t('tslContractors.documentCategories.other'), value: 7 }
        ]
      } else { // Carrier
        return [
          { text: this.$t('tslContractors.documentCategories.insurance'), value: 8 },
          { text: this.$t('tslContractors.documentCategories.license'), value: 9 },
          { text: this.$t('tslContractors.documentCategories.vat'), value: 10 },
          { text: this.$t('tslContractors.documentCategories.certificates'), value: 11 },
          { text: this.$t('tslContractors.documentCategories.other'), value: 12 }
        ]
      }
    }
  },
  created () {
    this.getDocumentsCount()
  },
  methods: {
    async getDocumentsCount () {
      this.loading = true
      try {
        const { data } = await Service.get('/TSLContractor/GetDocumentsCount', { contractorId: this.contractorId })
        this.documentsCount = data.documentsCounts || {}
        this.archivedCount = data.archivedCount || 0
      } catch (e) {
        // If endpoint doesn't exist yet, load all documents and count manually
        try {
          const { data } = await Service.get('/TSLContractor/GetDocuments', { contractorId: this.contractorId })
          const documents = data || []
          this.documentsCount = {}
          this.categories.forEach(cat => {
            this.documentsCount[cat.value] = documents.filter(d => d.type === cat.value && !d.isArchived).length
          })
          this.archivedCount = documents.filter(d => d.isArchived).length
        } catch (e2) {
          console.error('Error loading documents count:', e2)
        }
      } finally {
        this.loading = false
      }
    },
    getDocumentCount (type) {
      return this.documentsCount[type] || 0
    }
  }
}
</script>

<style scoped>
.v-tab {
  text-transform: none;
  border-left: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
.v-tab:last-child {
  border-right: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
</style>
